import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import orangeJumper from '../../images/orange-jump.svg';
import purpleJumper from '../../images/purple-jump.svg';

const carouselSettings = {
  showStatus: false,
  showThumbs: false,
  showArrows: false,
  autoPlay: true,
  interval: 10000,
};

const renderDots = (onClickHandler, isSelected, index, label) => {
  const onClick = (e) => {
    e.preventDefault();
    onClickHandler();
  };

  return (
    <li
      className={`reviewsslider__dot ${
        isSelected ? 'reviewsslider__dot--selected' : ''
      }`}
      onClick={onClick}
      onKeyDown={onClick}
      value={index}
      key={index}
      role="button"
      tabIndex={0}
      aria-label={`${label} ${index + 1}`}
      aria-hidden="true"
    />
  );
};

const ReviewsSlider = ({ model }) => {
  return (
    <div className="reviewsslider row columns" style={{background: model.reviewsSliderBlockBackgroundColor}}>
      {model.videoLink && (
        <div className="reviewsslider__video">
          <iframe
            className="reviewsslider__video-iframe"
            src={'https://www.youtube.com/embed/' + model.videoLink}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
          ></iframe>
        </div>
      )}
      {model.reviews.length > 0 && (
        <div className="reviewsslider__reviews">
          <div className="reviewsslider__reviews__top">
            <img
              src={purpleJumper}
              className="reviewsslider__reviews__top-img"
              alt="image of bodyflyer"
            />
          </div>
          <Carousel {...carouselSettings} renderIndicator={renderDots}>
            {model.reviews.map((review, index) => (
              <div key={index} className="reviewsslider__reviews__content">
                <p className="reviewsslider__reviews__content-text" style={{color: model.reviewsSliderBlockTextColor}}>
                  {review.text}
                </p>
                <p className="reviewsslider__reviews__content-name" style={{color: model.reviewsSliderBlockNameColor}}>
                  {review.name}
                </p>
                <p className="reviewsslider__reviews__content-location" style={{color: model.reviewsSliderBlockLocationColor}}>
                  {review.location}
                </p>
              </div>
            ))}
          </Carousel>
          <div className="reviewsslider__reviews__bot">
            <img
              src={orangeJumper}
              className="reviewsslider__reviews__bot-img"
              alt="image of bodyflyer"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewsSlider;
